import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('./exchange-reward-score/index.vue')
const Rank = () => import('./exchange-reward-score/Rank/Rank.vue')
const Record = () => import('./exchange-reward-score/RecordList.vue')

export const indexRoute: RouteConfig = {
  path: '/exchange-reward-score-202412',
  name: 'exchange_reward_score_202412',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '积分兑换',
    ignoreLogin: true,
  },
}

export const recordRoute: RouteConfig = {
  path: '/exchange-reward-score-202412-record',
  name: 'exchange_reward_score_202412_record',
  component: Record,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '积分兑换',
    ignoreLogin: true,
  },
}

export const rankRoute: RouteConfig = {
  path: '/exchange-reward-score-202412-rank',
  name: 'exchange_reward_score_202412_rank',
  component: Rank,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '积分兑换',
    ignoreLogin: true,
  },
}

export default [indexRoute, rankRoute, recordRoute]

export function navigateToExchangeReward202412(router: VueRouter) {
  router.push({ name: indexRoute.name })
}
